import { html } from 'lit'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'

initializeIconsByRole({
  'csc-plp-filters.accordion-closed': { name: 'angle-down', style: 'light' },
  'csc-plp-filters.accordion-open': { name: 'angle-down', style: 'light' },
})

export const renderAccordionIcons = (size: string) => html`
  <cse-icon slot="icon-closed" icon-role="csc-plp-filters.accordion-closed" .size=${size}></cse-icon>
  <cse-icon slot="icon-open" icon-role="csc-plp-filters.accordion-open" .size=${size}></cse-icon>
`
